<template>
  <div class="bigBox">
    <div class="videoContainer">
      <video
        class="fullscreenVideo"
        id="bgVid"
        playsinline=""
        autoplay=""
        muted=""
        loop=""
      >
        <source src="../../assets/images/loginBgVideo.mp4" type="video/mp4" />
      </video>
    </div>
    <div class="loginArea">
      <img src="../../assets/images/loginHead.png" style="width: 100%;" />
      <div style="width: 440px; margin: auto">
        <LoginForm />
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "./huangshiLoginForm.vue";

export default {
  components: {
    LoginForm,
  },
};
</script>

<style lang="scss">
.bigBox {
  margin: 0px !important;
  width: 100%;
  height: 100%;
}

.videoContainer {
  position: fixed;
  width: 100%;
  height: 100%;
  // overflow: hidden;
  // z-index: -100;
}

.fullscreenVideo {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.videoContainer:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  z-index: -1;
  top: 0;
  left: 0;
  background: rgba(25, 29, 34, 0.65);
}

.loginArea {
  width: 100%;
  position: absolute;
  top: 10%;
}

.login-btn {
  color: #FFFFFF;
  font-size: 22px;
  height: 48px;
  width: 100%;
  background: linear-gradient(90deg, #135cec 0%, #6699ff 100%) !important;
}

.login-form {
  .el-input__inner {
    color: #fff;
    background: rgba(44, 103, 255, 0.15);
    border: 1px solid rgb(44, 103, 255);

    &:hover {
      background: rgba(44, 103, 255, 0.25);
    }
  }

  .el-input__inner::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.45);
  }
  .el-input__inner:-moz-placeholder {
    color: rgba(255, 255, 255, 0.45);
  }
  .el-input__inner:-ms-input-placeholder {
    color: rgba(255, 255, 255, 0.45);
  }
}

.prefixImageStyle{
  height: 50%;
  margin-left: 6px;
  margin-top: 10px;
}

.sizi{
  width: 100% !important;
  color: rgba(255, 255, 255, 0.45);
}

.lock-box{
  position: relative;
  bottom: 32px;
}

.lock{
  width: 95px;
  background: url('../../assets/images/icon-lock.png');
  opacity: 0.45;
}

.lock-box .lock {
    width: 100px;
    height: 110px;
    margin: 0 auto;
}

.lock-box button {
    height: 48px;
    margin-top: 8px;
}

</style>
